/* @jsxImportSource react */

import { flag, icon, label } from './TireEfficiencyFlag.variants';

export type TireEfficiencyFlagSpecificProps = {
  /** flag type */
  type: 'fuelEfficiency' | 'wetGrip' | 'externalRollingNoise';
  /** text to display */
  text: string;
  /** Which display variant to use
   * - 'large' for a large flag
   * - 'normal' for a small flag with a large font size, matching the {@link ProductPrice} font size for legal requirements
   * - 'small' for a small flag with a small font size, matching the `small` variant of the {@link ProductPrice}
   *
   * @default 'normal'
   */
  size?: 'large' | 'normal' | 'small';
};

export type TireEfficiencyFlagProps = TireEfficiencyFlagSpecificProps &
  React.HTMLAttributes<HTMLDivElement>;

export const TireEfficiencyFlag = ({
  className,
  type,
  text,
  size = 'normal',
  'aria-label': ariaLabel,
  ...props
}: TireEfficiencyFlagProps) => (
  <div className={flag({ size, className })} {...props}>
    <span aria-label={ariaLabel} className={icon({ size, type })} />
    <span className={label({ size })}>{text}</span>
  </div>
);

TireEfficiencyFlag.displayName = 'TireEfficiencyFlag';
